import { Controller } from "@hotwired/stimulus"

// Conditionally shows a fade/chevron indicator when tab container overflows horizontally.
// Targets:
//   container - the scrollable element
//   indicator - the fade overlay element (toggled via hidden class)
export default class extends Controller {
  static targets = ["container", "indicator"]

  connect() {
    this.checkOverflow = this.checkOverflow.bind(this)
    this.resizeObserver = new ResizeObserver(this.checkOverflow)
    this.resizeObserver.observe(this.containerTarget)
    this.containerTarget.addEventListener("scroll", this.checkOverflow, { passive: true })
    this.checkOverflow()
    this.scrollToActiveTab()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    this.containerTarget?.removeEventListener("scroll", this.checkOverflow)
  }

  scrollToActiveTab() {
    const activeTab = this.containerTarget.querySelector('[aria-current="page"]')
    if (!activeTab) return

    activeTab.scrollIntoView({ inline: "center", block: "nearest", behavior: "instant" })
    this.checkOverflow()
  }

  checkOverflow() {
    if (!this.hasContainerTarget || !this.hasIndicatorTarget) return

    const { scrollWidth, clientWidth, scrollLeft } = this.containerTarget
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1
    this.indicatorTarget.classList.toggle("hidden", scrollWidth <= clientWidth || atEnd)
  }
}
